<template>
  <div class="calendar_body_day">
    <div class="calendar_body_day_box" @click.stop.prevent="handleSelectDay()">
      <div v-if="dayData.length > 0" class="calendar_body_day_text_small">{{ day }}</div>
      <div v-else :class="{'calendar_body_day_text' : true, 'calendar_body_day_text__sunday' : isSunday, 'calendar_body_day_text__another_month' : isAnotherMonth}">{{ day }}</div>
      <div v-if="dayData.length > 0" class="calendar_body_day_data">
        <div
          v-for="(item, idx) in getDayData"
          :key="idx"
          :class="{'calendar_body_day_item': true, 'expand': selectedItemId === item.id, 'calendar_body_day_item__big': dayData.length === 1 }"
        >
          <div class="calendar_body_day_item_data" @click.stop.prevent="handleSelectItem(item.id)">
            <div v-if="selectedItemId === item.id" class="calendar_body_day_item_notes">
              Currently Selected
            </div>
            <div class="calendar_body_day_item_logo">
              <img class="lazyload calendar_body_day_item_img" :data-src="item.img">
            </div>
          </div>
        </div>
        <div v-if="countDayData > numberItemShowed" class="calendar_body_day_item" @click.stop.prevent="handleToggleSeeMoreItems()">
          <div v-click-outside="closeSeeMoreItems" class="calendar_body_day_item_data">
            <svg-icon v-if="showMoreItems" name="chevron-up" color="#ffffff" />
            <svg-icon v-else name="chevron-down" color="#ffffff" />
          </div>
        </div>
        <div class="calendar_body_day_dropdown_content" :style="showMoreItems ? 'display: flex' : 'display: none'">
          <div
            v-for="(item, idx) in getDayDataExpand"
            :key="'expand_' + idx"
            :class="{'calendar_body_day_item': true, 'expand': selectedItemId === item.id }"
          >
            <div class="calendar_body_day_item_data" @click.stop.prevent="handleSelectItem(item.id)">
              <div v-if="selectedItemId === item.id" class="calendar_body_day_item_notes">
                Currently Selected
              </div>
              <div class="calendar_body_day_item_logo">
                <img class="lazyload calendar_body_day_item_img" :data-src="item.img">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '../../shared/icons/index.vue';
import ClickOutside from 'vue-click-outside';
const _chunk = require('lodash.chunk');
const _drop = require('lodash.drop');

export default {
  components: { SvgIcon },
  directives: {
    ClickOutside,
  },
  props: {
    day: {
      type: Number,
      default: function() {
        return 1;
      },
    },
    isInTargetMonth: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    dayData: {
      type: Array,
      default: function() {
        return [];
      },
    },
    selectedItemId: {
      type: Number,
      default: function() {
        return 0;
      },
    },
    isSunday: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    isAnotherMonth: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    month: {
      type: Number,
      default: () => {
        return (new Date()).getMonth() + 1;
      },
    },
    year: {
      type: Number,
      default: () => {
        return (new Date()).getFullYear();
      },
    },
    dayString: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showMoreItems: false,
      numberItemShowed: 5,
    };
  },
  computed: {
    countDayData() {
      return this.dayData.length;
    },
    getDayData() {
      if (this.dayData.length > this.numberItemShowed) {
        return _chunk(this.dayData, this.numberItemShowed)[0];
      } else {
        return this.dayData;
      }
    },
    getDayDataExpand() {
      if (this.dayData.length > this.numberItemShowed) {
        return _drop(this.dayData, this.numberItemShowed);
      } else {
        return [];
      }
    },
  },
  watch: {
    selectedItemId: function(newVal, oldVal) {
      const checkIsSettingDay = this.dayData.filter(item => {
        return item.id === newVal;
      });
      if (checkIsSettingDay.length === 0) {
        this.numberItemShowed = 5;
      } else {
        this.numberItemShowed = 3;
        this.dayData = this.dayData.filter(item => {
          return item.id !== newVal;
        });
        this.dayData.unshift(checkIsSettingDay[0]);
        const imgs = document.getElementsByClassName('calendar_body_day_item_img');
        for (let i = 0; i < imgs.length; i++) {
          imgs[i].classList = 'calendar_body_day_item_img lazyload';
        }
      }
    },
  },
  methods: {
    handleSelectItem(id) {
      this.closeSeeMoreItems();
      this.$emit('click-item-day', { 'id': id, 'day': this.day });
    },
    handleSelectDay() {
      this.closeSeeMoreItems();
      if (this.dayData.length > 0) {
        this.$emit('click-item-day', { 'id': this.dayData[0].id, 'day': this.day });
      }
    },
    handleToggleSeeMoreItems() {
      this.showMoreItems = !this.showMoreItems;
    },
    closeSeeMoreItems() {
      this.showMoreItems = false;
    },
  },
};
</script>
